import React from "react";
import {Route, Switch} from "react-router-dom";

import asyncComponent from "util/asyncComponent";

const App = ({match}) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      <Route path={`${match.url}dashboard`} component={asyncComponent(() => import('./Dashboard'))}/>
      <Route path={`${match.url}master`} component={asyncComponent(() => import('./Master'))}/>
      <Route path={`${match.url}utility`} component={asyncComponent(() => import('./Utility'))}/>
      <Route path={`${match.url}trans`} component={asyncComponent(() => import('./Transaction'))}/>
      <Route path={`${match.url}user`} component={asyncComponent(() => import('./User'))}/>
    </Switch>
  </div>
);

export default App;
